<div>
  <div class="row">
    <div class="col-md-10 col-md-offset-1"><h2 *ngIf="type">{{type.name}} {{'modes_data'| translation}}</h2></div>
  </div>
  <div class="row">
    <div class="col-md-10 col-md-offset-1" *ngIf="menu.length > 0">
      <button pButton (click)="modeMenu.toggle($event)" severity="primary" >{{'mode_choose'| translation}}<i class="fa-solid fa-caret-down"></i></button>
      <p-menu #modeMenu [model]="menu" [popup]="true" [appendTo]="'body'"></p-menu>
    </div>
  </div>
<div class="row">
  <div class="col-md-10 col-md-offset-1">
    <p>{{'or'| translation|uppercase}}</p>
    <label>{{'mode_create_new'| translation}}</label>
    <p-inputgroup>
      <input pInputText type="text" #newModeName="ngModel" noWhiteSpace [(ngModel)]="newMode" [name]="newMode">
      <p-inputgroup-addon>
        <button pButton severity="primary" (click)="createMode(newMode)" [disabled]="newModeName.invalid || exists(newMode)">
          {{'mode_add'| translation}}
        </button>
      </p-inputgroup-addon>
    </p-inputgroup>
    <div class="error-msg" *ngIf="exists(newMode)">{{'mode_already_exist'| translation}}.</div>

    <div class="error-msg" *ngIf="newModeName.errors && newModeName.errors.noWhiteSpace">{{'mode_no_white_space'| translation}}.</div>
  </div>
  </div>
</div>
